import { ActionReducer, MetaReducer } from '@ngrx/store';
import { CORE_ACTIONS } from '@ispm/core/constants/core-actions.constant';
import {
  Actions,
  ActionTypes,
  StateTypes,
} from '@ispm-client/modules/similar-patients/store/actions/similar-patients.actions';
import {
  buildSimilarPatientsKeys,
  initialState,
  SimilarPatientsDataState
} from '@ispm-client/modules/similar-patients/store';

export function similarPatientsReducer(state = initialState, action: Actions) {

  switch (action.type) {

    case ActionTypes.SET_CURRENT_PATIENT_DATA:

      return {
        ...state,
        currentPatient: action.payload.currentPatientData,
        stateSuccess: null,
        error: null
      };

    case ActionTypes.SET_SIMILAR_PATIENTS_DATA:
      let newPatientsData = new Map(state.patientsData);
      let keys = buildSimilarPatientsKeys(action.payload.similarPatientsKeys);
      newPatientsData.set(keys, action.payload.similarPatientsData);

      return {
        ...state,
        patientsData: newPatientsData,
        stateSuccess: null,
        error: null
      };

    case ActionTypes.CLEAR_SIMILAR_PATIENTS_DATA:
      return {
        ...state,
        patientsData: new Map(),
        stateSuccess: null,
        error: null
      };

    case ActionTypes.SIMILAR_PATIENTS_SEARCH_SUCCESS:
      return {
        ...state,
        patientsData: new Map(state.patientsData),
        stateSuccess: {
          stateType: StateTypes.SEARCH_SIMILAR_PATIENTS
        },
        error: null
      };

    case ActionTypes.SET_ERROR:
      return {
        ...state,
        error: {
          stateType: action.payload.stateType,
          error: action.payload.error
        }
      };

    default:
      return { ...state }
  }

}

export function clearStateReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action: any) {
    if (! state || action.type === CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS) {
      return initialState;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [ clearStateReducer ];
